module.exports = __webpack_public_path__ + "img/image4.41b2ab2c.png";